<script>
  export let content = {
    subjectsIconImgSrc: '',
    subjectsIconImgAltTxt: '',
    subjectsSectionTitle: '',
    subjects: [{
      imgSrc: '',
      imgSrcAltTxt: '',
      title: '',
      content: ''
    }]
  };
</script>

<section class="font-poppins px-[3rem] pt-[3rem] sm:pt-[6rem] pb-[5rem]">
  <div class="flex justify-center flex-col items-center mb-[5rem]">
    <img
      class="w-[3.8rem] sm:w-[4.5rem] md:w-[7rem]"
      src="{content.subjectsIconImgSrc}"
      width="30"
      height="30"
      alt="{content.subjectsIconImgAltTxt}"/>
    <h2 class="leading-[unset] text-center bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent text-[3rem] sm:text-[4.5rem] font-bold md:text-[5rem]">
      {content.subjectsSectionTitle}
    </h2>
  </div>

  <div class="grid grid-cols-1 gap-14 justify-items-center items-center sm:gap-[4.5rem] md:grid-cols-2 md:gap-20 md:mx-auto md:max-w-[113rem]">
    {#each content.subjects as subject}
      <div class="flex flex-col items-center max-w-[40rem] sm:max-w-[54rem]">
        <img
          class="subject-img w-[20rem] sm:w-[32rem]"
          src="{subject.imgSrc}"
          width="100"
          height="100"
          alt="{subject.imgSrcAltTxt}"
        />
        <h3 class="text-center subject-title text-darkBlue text-[2rem] font-semibold mb-[1rem] sm:text-[3.5rem] md:mb-4">
          {subject.title}
        </h3>
        <p class="subject-text text-[#63637a] text-[1.4rem] leading-[1.7rem] text-center sm:text-[2rem] sm:leading-[2.8rem] md:text-[2.2rem] md:leading-[3rem]">
          {subject.content}
        </p>
      </div>
    {/each}
  </div>
</section>